// extracted by mini-css-extract-plugin
export default {"inner":"result_inner__2VDxD","isContainer":"result_isContainer__3P7aZ","container":"result_container__L7GdD","image":"result_image__OIhVZ","description":"result_description__1UPo0"};